var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWithNameWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.1,
    height: 24.1,
    viewBox: "0 0 138.1 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st20 {fill: #ffffff;} .st1 {fill: #ff385c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    className: "st1",
    d: "M14.1,2c-.1.1,0,8.6,0,8.6H5.8s.1-8.5,0-8.6S.2,1.9.1,2,0,23.6.1,23.8c.1.1,5.5.1,5.7,0s0-8.8,0-8.8h8.3s-.1,8.6,0,8.8,5.5.1,5.7,0c.1-.1.1-21.7,0-21.8-.1-.1-5.5-.1-5.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    className: "st1",
    d: "M26,0c-.3,0-.5,0-.8,0s-.3,0-.4,0c-.2,0-.5,0-.7,0-.2,0-.4,0-.6.2-1,.4-1.5,1.2-1.5,2.4s.5,2.1,1.5,2.4c.2,0,.4.1.6.2.2,0,.5,0,.7,0h.4c.3,0,.5,0,.8,0,1.7-.2,2.5-1,2.5-2.6S27.7.2,26,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    className: "st1",
    d: "M22.4,7.3c-.1.1-.1,16.4,0,16.5s5.5.1,5.6,0,.1-16.4,0-16.5-5.5-.1-5.6,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    className: "st20",
    d: "M29.6,2c-.1.1-.2,4.2,0,4.4.1.1,4.7,0,4.7,0,0,0-.1,17.2,0,17.4s5.5.1,5.7,0,0-17.4,0-17.4c0,0,6.2.1,6.3,0s.1-4.2,0-4.4-16.5-.1-16.6,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    className: "st20",
    d: "M79,7c-5.5,0-8.6,3.1-8.6,8.6s3.1,8.6,8.9,8.6,7.4-4.1,7.2-4.4-3.7-1.4-4.2-1.4-1.4,1.8-3,1.8-3.1-.8-3.5-3c0,0,11.1.1,11.3,0s.2-1.3.2-1.8c0-5.2-2.9-8.4-8.3-8.4M75.9,14.1c.3-2.2,1.4-3.2,3.1-3.2s2.8,1.1,3.1,3.2h-6.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    className: "st20",
    d: "M100,7c-2.6,0-4.6,1.2-5.6,3.5,0,0,0-3.1-.2-3.2s-4.9-.1-5,0-.1,16.4,0,16.5,5.5.1,5.6,0,0-8.7,0-8.7c0-2.7,1.4-3.8,3-3.8s2.3.8,2.3,3.1c0,0-.1,9.3,0,9.4s5.5.1,5.6,0,0-11,0-11c0-3.8-2.3-5.8-5.7-5.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    className: "st20",
    d: "M129.4,7c-5.5,0-8.7,3.2-8.7,8.6s3.2,8.6,8.7,8.6,8.7-3.2,8.7-8.6-3.2-8.6-8.7-8.6M129.4,20.1c-2.1,0-3.1-1.4-3.1-4.6s1-4.6,3.1-4.6,3.1,1.4,3.1,4.6-1,4.6-3.1,4.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    className: "st20",
    d: "M68.7,20.1c-1.2,0-1.5-.6-1.5-2,0,0,.1-17.6,0-17.8s-5.5-.1-5.6,0c-.1.1,0,18.6,0,18.6,0,3.7,1.5,5.2,5,5.2s3.3-.7,3.4-.8.5-3.3.4-3.5-1,.3-1.7.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    className: "st20",
    d: "M59.8,20.5c-.8,0-1.2-.4-1.2-1.3v-6c0-4.2-2.8-6.3-7.9-6.3s-7.5,4.6-7.1,5.1c.2.2,3.6,1.3,4.1,1.3s1.5-2.5,3.1-2.5,2.3,1,2.3,2.4v.6l-3.7.7c-4.7.9-6.4,2.7-6.4,5.4s1.8,4.1,5.1,4.1,4.9-1,5.9-2.5c.5,1.8,2,2.5,4.2,2.5s2.1-.4,2.2-.5.5-3,.4-3.1-.6.1-1,.1M53.1,18.1c0,1.5-1.6,2.3-3,2.3s-1.6-.5-1.6-1.4.6-1.4,1.9-1.7l2.7-.6v1.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    className: "st20",
    d: "M117.5,20.1c-1.4,0-2.2-.6-2.2-2.2v-6.6s4.8.1,4.9,0,.1-3.8,0-4-4.9,0-4.9,0c0,0,.5-5.2,0-5.2s-5.4,1.4-5.6,1.6,0,3.7,0,3.7c0,0-2.7-.1-2.8,0s-.1,3.8,0,4,2.8,0,2.8,0v7.5c0,3.8,2.3,5.3,6.1,5.3s4.5-1.1,4.7-1.3-.4-3.3-.6-3.5-1.3.7-2.4.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithNameWhite);
export default __webpack_public_path__ + "static/media/logo_with_name_white.5d4eb5a99c1c89f33166297c3326077d.svg";
export { ForwardRef as ReactComponent };